import request from '../../config/axiosConfig';
import {
  CREATE_CATEGORY_WEB,
  DELETE_CATEGORY_WEB,
  GET_ALL_BLOGS_WEB,
  SEARCH_CATEGORY_WEB,
  UPDATE_CATEGORY_WEB,
} from '../../constants/apiEndPoint';

const blogService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_ALL_BLOGS_WEB, method: 'POST', params });
    // Trả về data.data nếu có (thường là list từ server), nếu không trả về nguyên data
    return data;
  },

  // getDetail: async (id) => {
  //   const { data } = await request(GET_BLOCK_VIDEO_INFO, { id });
  //   return data?.data || data;
  // },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_CATEGORY_WEB, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    // Giả sử API update cần cả id và body
    const { data } = await request({ url: UPDATE_CATEGORY_WEB, method: 'POST', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_CATEGORY_WEB, method: 'POST', data: { id } });
    return data;
  },

  search: async (params) => {
    const { data } = await request({
      url: SEARCH_CATEGORY_WEB,
      method: 'POST',
      params,
    });
    return data;
  },
};

export default blogService;
